import { DataTableColumnProps } from './DataTableColumnProps';

// This is only used by the parent DataTable and does not render anything, therefore:
// eslint-disable-next-line no-empty-pattern
export const DataTableColumn = <T,>({}: DataTableColumnProps<T>) => <></>;
